module.exports = __webpack_public_path__ + "img/xzIco (2).61f5ea75.png";